/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import {
	isEqual, isEmpty, isNull, find,
} from 'lodash';

class Select extends Component {
	constructor(props) {
		super(props);

		const {
			options,
			value : rawValue,
		} = this.props;

		let value = null;

		if (!isNull(rawValue)) value = find(options, ['value', rawValue]) || null;

		this.state = {
			value,
		};
	}

	static getDerivedStateFromProps(nextProps, lastState) {
		const newState = {};
		let value = null;

		if (!isNull(nextProps.value)) value = find(nextProps.options, ['value', nextProps.value]) || null;

		if (!isEqual(value, lastState.value)) newState.value = value;

		return !isEmpty(newState) ? newState : null;
	}

	shouldComponentUpdate = ({
		autoFocus,
		className,
		classNamePrefix,
		isDisabled,
		isMulti,
		isSearchable,
		name,
		options,
		placeholder,
		isLoading,
	}, {
		value,
	}) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(autoFocus, lastProps.autoFocus)
			|| !isEqual(className, lastProps.className)
			|| !isEqual(classNamePrefix, lastProps.classNamePrefix)
			|| !isEqual(isDisabled, lastProps.isDisabled)
			|| !isEqual(isMulti, lastProps.isMulti)
			|| !isEqual(isSearchable, lastProps.isSearchable)
			|| !isEqual(name, lastProps.name)
			|| !isEqual(options, lastProps.options)
			|| !isEqual(placeholder, lastProps.placeholder)
			|| !isEqual(isLoading, lastProps.isLoading)
			|| !isEqual(value, lastState.value)
		);
	}

	render() {
		const { props } = this;
		const { value } = this.state;

		return (
			<ReactSelect
				{...props}
				value={value}
			/>
		);
	}
}

Select.propTypes = {
	className       : PropTypes.string,
	classNamePrefix : PropTypes.string,
	options         : PropTypes.array,
	value           : PropTypes.any,
	autoFocus       : PropTypes.bool,
	isDisabled      : PropTypes.bool,
	isMulti         : PropTypes.bool,
	isSearchable    : PropTypes.bool,
	name            : PropTypes.string,
	placeholder     : PropTypes.string,
	isLoading       : PropTypes.bool,
};

Select.defaultProps = {
	autoFocus       : false,
	className       : 'react-select',
	classNamePrefix : 'react-select',
	options         : [],
	value           : null,
	isDisabled      : false,
	isMulti         : false,
	isSearchable    : false,
	name            : '',
	placeholder     : 'Select...',
	isLoading       : false,

};

export default Select;
